import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { UsersIcon, CheckCircleIcon, ArrowRightIcon, ChevronRightIcon, LayersIcon, TargetIcon, CalendarIcon, TrendingUpIcon, ShieldCheckIcon, ClipboardListIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { ContactForm } from '../../components/ContactForm';
function HeroSection() {
  return <section className="relative pt-20 lg:pt-24 pb-20 overflow-hidden bg-gradient-to-br from-primary-900 via-primary-800 to-navy-900" data-id="element-1199">
      <div className="absolute inset-0" data-id="element-1200">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-400/10 blur-3xl" data-id="element-1201" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-cyan-500/8 blur-3xl" data-id="element-1202" />
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,1) 1px, transparent 0)`,
        backgroundSize: '32px 32px'
      }} data-id="element-1203" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-1204">
        <motion.nav initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex items-center gap-1.5 text-sm text-primary-300/70 mb-10" data-id="element-1205">
          <Link to="/" className="hover:text-primary-300 transition-colors" data-id="element-1206">
            Головна
          </Link>
          <ChevronRightIcon className="w-3.5 h-3.5" data-id="element-1207" />
          <Link to="/#services" className="hover:text-primary-300 transition-colors" data-id="element-1208">
            Послуги
          </Link>
          <ChevronRightIcon className="w-3.5 h-3.5" data-id="element-1209" />
          <span className="text-primary-200" data-id="element-1210">Комплектація команди</span>
        </motion.nav>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1211">
          <div data-id="element-1212">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.05
          }} className="flex items-center gap-3 mb-6" data-id="element-1213">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-400 to-cyan-500 text-white shadow-xl shadow-primary-500/30" data-id="element-1214">
                <UsersIcon className="w-6 h-6" data-id="element-1215" />
              </div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-500/20 text-primary-300 text-xs font-semibold rounded-full border border-primary-500/20" data-id="element-1216">
                Команди під ключ
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.55,
            delay: 0.1
          }} className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.08]" data-id="element-1217">
              Комплектація <span className="text-cyan-400" data-id="element-1218">команди</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.18
          }} className="mt-6 text-xl text-primary-200/80 leading-relaxed" data-id="element-1219">
              Формування цілих відділів та команд під ключ — від визначення
              структури до виходу останнього спеціаліста на роботу.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.25
          }} className="mt-8 flex flex-wrap gap-4" data-id="element-1220">
              <a href="#contact" className="inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-primary-900 bg-white rounded-xl hover:bg-primary-50 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-1221">
                Залишити заявку
                <ArrowRightIcon className="w-4 h-4" data-id="element-1222" />
              </a>
              <a href="#cases" className="inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-white border border-white/20 rounded-xl hover:bg-white/10 transition-all" data-id="element-1223">
                Наші кейси
              </a>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4" data-id="element-1224">
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-1225">
              <div className="text-4xl font-extrabold text-white" data-id="element-1226">6</div>
              <div className="text-sm text-primary-300/70 mt-1" data-id="element-1227">
                тижнів — команда з 15 людей
              </div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-1228">
              <div className="text-4xl font-extrabold text-cyan-400" data-id="element-1229">50+</div>
              <div className="text-sm text-primary-300/70 mt-1" data-id="element-1230">
                команд сформовано
              </div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-1231">
              <div className="text-4xl font-extrabold text-white" data-id="element-1232">100%</div>
              <div className="text-sm text-primary-300/70 mt-1" data-id="element-1233">
                гарантія заміни
              </div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-1234">
              <div className="text-4xl font-extrabold text-cyan-400" data-id="element-1235">3–50</div>
              <div className="text-sm text-primary-300/70 mt-1" data-id="element-1236">
                людей у команді
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function WhatIsIncluded() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="py-20 lg:py-28 bg-white" ref={ref} data-id="element-1237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-1239">
          <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-1240">
            Що входить
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-1241">
            Повний цикл формування команди
          </h2>
          <p className="mt-4 text-lg text-navy-500 max-w-2xl mx-auto" data-id="element-1242">
            Від аналізу потреб до онбордингу останнього спеціаліста — ми беремо
            на себе весь процес
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1243">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="p-8 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-1244">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-cyan-500 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-1245">
              <LayersIcon className="w-5 h-5" data-id="element-1246" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1247">
              Організаційне проєктування
            </h3>
            <p className="text-navy-500 leading-relaxed mb-4" data-id="element-1248">
              Допомагаємо визначити оптимальну структуру команди, ролі та зони
              відповідальності ще до початку пошуку.
            </p>
            <ul className="space-y-2" data-id="element-1249">
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1250">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1251" />
                Аналіз бізнес‑потреб та цілей
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1252">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1253" />
                Розробка організаційної структури
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1254">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1255" />
                Визначення пріоритетності найму
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="p-8 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-1256">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-cyan-500 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-1257">
              <TargetIcon className="w-5 h-5" data-id="element-1258" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1259">
              Паралельний пошук
            </h3>
            <p className="text-navy-500 leading-relaxed mb-4" data-id="element-1260">
              Одночасно ведемо пошук за всіма позиціями — це скорочує загальний
              термін формування команди на 40%.
            </p>
            <ul className="space-y-2" data-id="element-1261">
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1262">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1263" />
                Виділена команда рекрутерів
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1264">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1265" />
                Спеціалізація за напрямками
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1266">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1267" />
                Єдиний дедлайн для всіх позицій
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="p-8 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-1268">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-cyan-500 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-1269">
              <ClipboardListIcon className="w-5 h-5" data-id="element-1270" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1271">
              Координація процесу
            </h3>
            <p className="text-navy-500 leading-relaxed mb-4" data-id="element-1272">
              Один менеджер проєкту координує весь процес. Ви отримуєте єдину
              точку контакту та повну прозорість.
            </p>
            <ul className="space-y-2" data-id="element-1273">
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1274">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1275" />
                Щотижневі статус‑зустрічі
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1276">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1277" />
                Дашборд прогресу в реальному часі
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1278">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1279" />
                Проактивна комунікація
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="p-8 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-1280">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-cyan-500 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-1281">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-1282" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1283">
              Гарантія результату
            </h3>
            <p className="text-navy-500 leading-relaxed mb-4" data-id="element-1284">
              Фіксуємо дедлайни у договорі. Гарантія безкоштовної заміни для
              кожного члена команди.
            </p>
            <ul className="space-y-2" data-id="element-1285">
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1286">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1287" />
                Фіксований дедлайн у договорі
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1288">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1289" />
                100% гарантія заміни
              </li>
              <li className="flex items-center gap-2 text-sm text-navy-600" data-id="element-1290">
                <CheckCircleIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-1291" />
                Підтримка після виходу команди
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}
function CasesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="py-20 lg:py-28 bg-navy-50/40" id="cases" ref={ref} data-id="element-1292">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1293">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-1294">
          <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-1295">
            Кейси
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-navy-900 tracking-tight" data-id="element-1296">
            Команди, які ми зібрали
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1297">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="p-7 rounded-2xl bg-white border border-navy-100 shadow-sm" data-id="element-1298">
            <div className="flex items-center gap-2 mb-4" data-id="element-1299">
              <CalendarIcon className="w-4 h-4 text-primary-500" data-id="element-1300" />
              <span className="text-xs font-semibold text-navy-400 uppercase tracking-wide" data-id="element-1301">
                Фінтех
              </span>
            </div>
            <div className="text-4xl font-extrabold text-primary-600 mb-1" data-id="element-1302">
              15
            </div>
            <div className="text-sm font-semibold text-navy-700 mb-3" data-id="element-1303">
              спеціалістів за 6 тижнів
            </div>
            <p className="text-sm text-navy-500 leading-relaxed" data-id="element-1304">
              IT‑відділ для фінтех‑стартапу після раунду Series A. Frontend,
              Backend, DevOps, QA та Team Lead.
            </p>
            <div className="mt-4 pt-4 border-t border-navy-100" data-id="element-1305">
              <div className="text-xs text-emerald-600 font-semibold" data-id="element-1306">
                ✓ 100% пройшли випробувальний термін
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="p-7 rounded-2xl bg-white border border-navy-100 shadow-sm" data-id="element-1307">
            <div className="flex items-center gap-2 mb-4" data-id="element-1308">
              <CalendarIcon className="w-4 h-4 text-primary-500" data-id="element-1309" />
              <span className="text-xs font-semibold text-navy-400 uppercase tracking-wide" data-id="element-1310">
                Рітейл
              </span>
            </div>
            <div className="text-4xl font-extrabold text-primary-600 mb-1" data-id="element-1311">
              8
            </div>
            <div className="text-sm font-semibold text-navy-700 mb-3" data-id="element-1312">
              менеджерів за 4 тижні
            </div>
            <p className="text-sm text-navy-500 leading-relaxed" data-id="element-1313">
              Відділ продажів для e‑commerce компанії. Регіональні менеджери та
              керівник відділу.
            </p>
            <div className="mt-4 pt-4 border-t border-navy-100" data-id="element-1314">
              <div className="text-xs text-emerald-600 font-semibold" data-id="element-1315">
                ✓ +35% до виручки за квартал
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="p-7 rounded-2xl bg-white border border-navy-100 shadow-sm" data-id="element-1316">
            <div className="flex items-center gap-2 mb-4" data-id="element-1317">
              <CalendarIcon className="w-4 h-4 text-primary-500" data-id="element-1318" />
              <span className="text-xs font-semibold text-navy-400 uppercase tracking-wide" data-id="element-1319">
                Логістика
              </span>
            </div>
            <div className="text-4xl font-extrabold text-primary-600 mb-1" data-id="element-1320">
              12
            </div>
            <div className="text-sm font-semibold text-navy-700 mb-3" data-id="element-1321">
              операційних менеджерів за 5 тижнів
            </div>
            <p className="text-sm text-navy-500 leading-relaxed" data-id="element-1322">
              Операційний відділ для логістичної компанії при масштабуванні на
              нові регіони.
            </p>
            <div className="mt-4 pt-4 border-t border-navy-100" data-id="element-1323">
              <div className="text-xs text-emerald-600 font-semibold" data-id="element-1324">
                ✓ Вихід на 3 нові ринки
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function CtaBanner() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5
  }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1325">
      <div className="p-8 sm:p-12 rounded-3xl bg-gradient-to-br from-primary-900 via-primary-800 to-navy-900 relative overflow-hidden" data-id="element-1326">
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-cyan-500/10 blur-3xl" data-id="element-1327" />
        <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-primary-400/10 blur-3xl" data-id="element-1328" />
        <div className="relative z-10 flex flex-col sm:flex-row items-center gap-6 sm:gap-10" data-id="element-1329">
          <div className="flex-1" data-id="element-1330">
            <h3 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight" data-id="element-1331">
              Потрібна команда під ключ?
            </h3>
            <p className="mt-2 text-primary-200/80 leading-relaxed" data-id="element-1332">
              Розкажіть про вашу задачу — ми розробимо план формування команди
              та запропонуємо терміни.
            </p>
          </div>
          <a href="#contact" className="flex-shrink-0 inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-primary-900 bg-white rounded-xl hover:bg-primary-50 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-1333">
            Залишити заявку
            <ArrowRightIcon className="w-4 h-4" data-id="element-1334" />
          </a>
        </div>
      </div>
    </motion.div>;
}
export function TeamBuildingPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-1335">
      <Header data-id="element-1336" />
      <main className="pt-16 lg:pt-20" data-id="element-1337">
        <HeroSection data-id="element-1338" />
        <WhatIsIncluded data-id="element-1339" />
        <CasesSection data-id="element-1340" />
        <CtaBanner data-id="element-1341" />
        <div id="contact" data-id="element-1342">
          <ContactForm data-id="element-1343" />
        </div>
      </main>
      <Footer data-id="element-1344" />
    </div>;
}